module.exports = __webpack_public_path__ + "img/brand-icon7.f91dbf6e.jpg";